<script setup lang="ts">
import Message from 'primevue/message';
import Button from 'primevue/button';

defineProps({
  errorMessage: { type: String, required: true },
  tryAgainLabel: { type: String, default: 'Opnieuw proberen' },
  showTryAgain: { type: Boolean, default: true },
})

const emit = defineEmits({
    tryAgain: null,
});

</script>

<template>
    <div class="flex flex-col items-center">
        <Message severity="error" variant="simple">
            <template #icon>
                <aeg-icon icon="pi pi-exclamation-circle" />
            </template>
            {{errorMessage}}
        </Message>
        <div v-if="showTryAgain">
            <Button
                variant="link"
                icon="pi pi-refresh"
                :label="tryAgainLabel"
                @click="emit('tryAgain')"
                class="p-0"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
